import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import AboutCard from './aboutCard/AboutCard';
import DetailsCard from './detailsCard.js/DetailsCard';

const ProfileCard = (props) => {
  const { page, profileObj,editButton,statusChange } = props;
  return (
    <Grid
      container
      gap={2}
      className="mt10 profileVendorMain"
      flexWrap="nowrap"
      justifyContent={'space-between'}
    >
      <Grid
        container
        item
        xs={12}
        md={page === 'vehicle' ? 12 : 8}
        lg={page === 'vehicle' ? 12 : 9}
        direction="column"
        className="subHeaderShadow height270"
      >
        {props?.loader ? (
          <Skeleton variant="rounded" className="skeltonHeight270" />
        ) : (
          <DetailsCard {...profileObj} type={page} statusChange={statusChange}/>
        )}
      </Grid>
      {page !== 'vehicle' && (
        <Grid
          container
          item
          xs={12}
          md={4}
          lg={3}
          className="bgWhite p20 height270"
        >
          {props?.loader ? (
            <Skeleton variant="rounded" className="height270" />
          ) : (
            <AboutCard {...profileObj} editButton={editButton}/>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default ProfileCard;
